import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import { BlogService } from 'src/app/api/blog.service';
import { BlogPost, BlogPostType } from 'src/app/models/blog';

interface Timer {
  days: number;
  hours: number;
  minutes: number;
}

@Component({
  selector: 'app-otc-page',
  templateUrl: './otc-page.component.html',
  styleUrls: ['./otc-page.component.scss']
})
export class OtcPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
}
